export const formatAppVersion = (rawTag: string | undefined, sha: string | undefined): string => {
  const version = rawTag ? rawTag.replace(/-\d+-g[0-9a-f]+$/i, '').replace(/^v+/, 'v') : 'dev';
  const shortSha = sha?.slice(0, 7);

  return shortSha ? `${version} (${shortSha})` : version;
};
